"use client";

import { LoginAccordion } from "@/components/auth/login-accordion";
import {
  LoginProviderOption,
  type LoginProviderOptionProps,
} from "@/components/auth/login-provider-option";
import type { LoginProviderSlot } from "@/lib/auth/resolve-login-providers";

type LoginOptionsProps = {
  accordion: LoginProviderSlot[];
  primary: LoginProviderSlot;
  providerProps: Omit<LoginProviderOptionProps, "isPrimary" | "slot">;
};

function LoginDivider() {
  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-background px-2 text-muted-foreground">or</span>
      </div>
    </div>
  );
}

export function LoginOptions({
  accordion,
  primary,
  providerProps,
}: LoginOptionsProps) {
  return (
    <div className="space-y-4">
      <LoginProviderOption isPrimary slot={primary} {...providerProps} />

      {accordion.length > 0 ? (
        <>
          <LoginDivider />
          <LoginAccordion>
            {accordion.map((slot) => (
              <LoginProviderOption
                isPrimary={false}
                slot={slot}
                {...providerProps}
                key={slot}
              />
            ))}
          </LoginAccordion>
        </>
      ) : null}
    </div>
  );
}
